import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id="services">
      <h5>What I Use</h5>
      <h2><h1>Tools</h1></h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Figma </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Adobe Xd </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Craft </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Sketch </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> InVision </p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <h3>Technologies & Programs</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Git</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Linux</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Redux </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Heroku </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> React Context API </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> REST framework</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <h3>2D || 3D Graphic Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Adobe Illustrator </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Adobe Photoshop </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Adobe After Effects </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Adobe Premier Pro </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Blender </p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p> Maya </p>
            </li>
          </ul>
        </article>
      </div>
      <hr />
    </section>
  )
}

export default Services